import React from 'react';
import { Control, FieldErrors, UseFormSetValue } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import SelectApi from '../../common/SelectApi';
import { WidgetOnlineWeighingProps } from '../Dashboard.types';

interface OnlineWeighingFiltersProps {
 control: Control<WidgetOnlineWeighingProps>;
 setValue: UseFormSetValue<WidgetOnlineWeighingProps>;
 errors: FieldErrors<WidgetOnlineWeighingProps>;
}

const OnlineWeighingFilters: React.FC<OnlineWeighingFiltersProps> = ({
 control,
 setValue,
}) => {
 const { t } = useTranslation();
 const scaleFilter = JSON.stringify({
  fields: 'Id,Name',
  filters: [{ field: 'DeviceType', operator: 'eq', value: 'Scales' }],
  limit: 50,
 });

 return (
  <SelectApi<WidgetOnlineWeighingProps>
   name="scale"
   url="/api/iot/v1/"
   filter={scaleFilter}
   label={t('dashboard.filters.scale')}
   isEditable
   operator="contains"
   control={control}
   setValue={setValue}
  />
 );
};

export default OnlineWeighingFilters;
